/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserRank } from 'models'
import { constants } from 'apps'
import { useAppDispatch, useLocalStorage } from 'hooks'
import MyHorseItemStyled from './styled'
import { getWinRate, shortenUserName } from 'utils/helper'

import { AVATAR_DEFAULT } from 'assets/images'
import RankCount from '../RankCount'
import { updateStateModal } from 'features/Profile/profile.slice'

interface UserItemProps {
  user: UserRank
}

function UserITem({ user }: UserItemProps) {
  const [userId] = useLocalStorage(constants.USER_ID_KEY, 0)
  const dispatch = useAppDispatch()
  const showModalUser = () => {
    if (user?.owner_id) {
      dispatch(updateStateModal({
        isOpen: true,
        userId: user?.owner_id,
      }))
    }
  }
  return (
    <MyHorseItemStyled mySelf={userId === user?.owner_id}>
      <td className='color-white stt width-25 center'>
        <RankCount rank={user?.rank} />
      </td>
      <td className='color-white width-30 horse-name'>
        <div className='horse-name-content'>
          <img src={user?.owner_avatar || AVATAR_DEFAULT} alt='avatar' className='horse-avatar' />
          <span onClick={showModalUser}>{shortenUserName(user?.owner_name)}</span>
        </div>
      </td>
      <td className='color-white width-20'>
        <span>
          {user?.total_number_of_races} {user?.first_count}/{user?.second_count}/{user?.third_count}
        </span>
      </td>
      <td className='color-white width-25'>{getWinRate(user)}</td>
    </MyHorseItemStyled>
  )
}

export default UserITem
